import { useSelector } from 'react-redux';

import type { RootState } from '../../../../store';

export default function useIntakeGeneralInfoUpdateLoading() {
  return useSelector(
    (state: RootState) => state.intakeQuestionnaire.updateGeneralInfoLoading,
  );
}
